"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTitleClassName = exports.useButtonVariantClass = void 0;
var theme_1 = require("../../../theme");
var common_utils_1 = require("../../../tools/common-utils");
var variants = {
    default: {
        border: 'squid-border-transparent',
    },
    primary: {
        border: 'squid-border-transparent',
    },
    contained: {
        border: 'squid-border-transparent',
    },
    outlined: {
        border: 'squid-border-alias-color-border-base',
    },
};
var disabledVariants = {
    default: {
        border: 'squid-border-transparent',
    },
    primary: {
        border: 'squid-border-transparent',
    },
    contained: {
        border: 'squid-border-transparent',
    },
    outlined: {
        border: 'squid-border-alias-color-border-base',
    },
};
var padding = {
    text: 'squid-px-component-simple-button-padding-base',
    iconLeft: 'squid-pl-component-simple-button-padding-tight squid-pr-component-simple-button-padding-base',
    iconRight: 'squid-pl-component-simple-button-padding-base squid-pr-component-simple-button-padding-tight',
    icons: 'squid-px-component-simple-button-padding-tight',
};
var useButtonVariantClass = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b, disabled = _a.disabled, active = _a.active, hasIcon = _a.hasIcon, hasText = _a.hasText, iconPosition = _a.iconPosition, branding = _a.branding;
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var bgStateColors = (0, theme_1.useBackgroundStateColors)(branding);
    var ring = (0, theme_1.useRingStyles)(branding);
    var classes = [];
    if (disabled) {
        var disabledClass = disabledVariants[variant];
        classes.push(__assign(__assign({}, disabledClass), { container: variant === 'outlined' ? bgColors.disabled : bgColors.transparent }));
    }
    if (!disabled) {
        var variantClass = __rest(variants[variant], []);
        var background = void 0;
        switch (variant) {
            case 'outlined':
                background = "".concat(bgColors.alt, " ").concat(bgStateColors.base);
                break;
            case 'contained':
                background = "".concat(bgColors.base, " ").concat(bgStateColors.base);
                break;
            case 'primary':
                background = "".concat(bgColors.transparent, " ").concat(bgStateColors.base);
                break;
            default:
                background = "".concat(bgColors.transparent, " ").concat(bgStateColors.base);
                break;
        }
        if (active && variant !== 'primary') {
            classes.push('squid-bg-alias-state-base-active hover:squid-bg-alias-state-base-active active:squid-bg-alias-state-base-active');
        }
        else {
            classes.push(background);
        }
        classes.push.apply(classes, (0, common_utils_1.toArray)(variantClass));
    }
    var sizeClassKey = 'text';
    if (hasIcon && hasText) {
        if (iconPosition === 'both') {
            sizeClassKey = 'icons';
        }
        else {
            sizeClassKey = iconPosition === 'left' ? 'iconLeft' : 'iconRight';
        }
    }
    classes.push(padding[sizeClassKey], ring.ring);
    return classes;
};
exports.useButtonVariantClass = useButtonVariantClass;
var useTitleClassName = function (variant, disabled, active, branding) {
    var textColors = (0, theme_1.useTextColors)(branding);
    var titleFontClassName = 'squid-text-alias-font-label-strong';
    if (disabled) {
        return {
            textColor: 'disabled',
            titleClasses: (0, common_utils_1.toArray)([
                titleFontClassName,
                textColors.disabled,
                "active:".concat(textColors['on-base-active']),
            ]),
        };
    }
    var isPrimary = variant === 'primary';
    if (active && !isPrimary) {
        return {
            textColor: 'on-base-active',
            titleClasses: (0, common_utils_1.toArray)([
                titleFontClassName,
                "".concat(textColors['on-base-active'], " active:").concat(textColors['on-base-active']),
            ]),
        };
    }
    var color = isPrimary
        ? "".concat(textColors['on-primary-variant'], " active:").concat(textColors['on-primary-variant'])
        : "".concat(textColors.weaker, " active:").concat(textColors['on-base-active']);
    return {
        textColor: isPrimary ? 'on-primary-variant' : 'weaker',
        titleClasses: (0, common_utils_1.toArray)([titleFontClassName, color]),
    };
};
exports.useTitleClassName = useTitleClassName;
